import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import autobind from 'autobind-decorator';
import EventNames from 'src/lib/eventNames';
import HvSvg from 'src/components/HvSvg';
import uiDux from 'src/redux/ui/';
import appDux from 'src/redux/app/';
import trackingDux from 'src/redux/tracking/';
import ElementStyleAttributeEditor from './ElementStyleAttributeEditor';
import {
  StyleAttributeContent,
  StyleAttributeEditorContainer,
  StyleAttributeText,
  StyleClearPaint,
} from './styled';

const { DESIGN_FEATURE_CLICK_OVERRIDDEN_COLOR } = EventNames.viewer;

const mapStateToProps = (state, props) => ({
  data: appDux.selectors.getDataForAttributeSelectionButton(state, props),
  isExtendedSidebarOpen: uiDux.selectors.isExtendedSidebarOpen(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      handleStyleAttributeButtonClick:
        uiDux.actions.handleStyleAttributeButtonClick,
      clearPaint: uiDux.actions.handleClearPaintClick,
      track: trackingDux.actions.track,
    },
    dispatch,
  );

export class ElementStyleAttribute extends PureComponent {
  @autobind
  handleClearPaintClick(e, style) {
    e.stopPropagation();

    this.props.clearPaint(style);
  }

  @autobind
  handleStyleAttributeClick(e) {
    e.stopPropagation();

    const {
      attribute,
      data,
      handleStyleAttributeButtonClick,
      style,
      track,
    } = this.props;
    const { available, isOverridden } = data;

    if (available && !isOverridden) {
      handleStyleAttributeButtonClick(style, attribute);
    } else if (isOverridden) {
      track(DESIGN_FEATURE_CLICK_OVERRIDDEN_COLOR);
    }
  }

  render() {
    const { attribute, data, style } = this.props;

    const {
      available,
      hasSelection,
      isCallToAction,
      isOverridden,
      isSelected,
      shouldDim,
      showClearPaintButton,
      text,
    } = data;

    return (
      <StyleAttributeEditorContainer
        data-selenium="styleAttributeEditor"
        disabled={!available}
        onClick={this.handleStyleAttributeClick}
        role="button"
        isSelected={isSelected}
        shouldDim={shouldDim}
        isOverridden={isOverridden}
      >
        <StyleAttributeContent isCallToAction={isCallToAction}>
          <ElementStyleAttributeEditor
            {...data}
            style={style}
            attribute={attribute}
          />
          <StyleAttributeText
            disabled={!available}
            data-selenium="attributeExtraText"
            hasSelection={hasSelection}
          >
            {text}
          </StyleAttributeText>
        </StyleAttributeContent>
        {showClearPaintButton && (
          <StyleClearPaint
            data-selenium="clearPaintButton"
            onClick={(e) => this.handleClearPaintClick(e, style)}
          >
            <HvSvg
              src={require('src/assets/images/ic-close.svg')}
              disabled={false}
            />
          </StyleClearPaint>
        )}
      </StyleAttributeEditorContainer>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ElementStyleAttribute);
